import React, { useEffect } from 'react'
import Container from 'react-bootstrap/cjs/Container'
import styled from 'styled-components'
import Button from 'react-bootstrap/cjs/Button'
import Card from 'react-bootstrap/cjs/Card'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'

import { _ } from 'utils'
import { $danger } from 'utils/colors'
import { fetchBooth, selectBooth } from '../config/fetchBoothSlice'
import { fetchJobs, selectJobs, Slugs } from './jobsSlice'
import JobsOverview from './JobsOverview'

const S = {
    Title: styled.h1`
        margin-bottom: 24px;
        font-size: 30px;
    `,
    Description: styled.p`
        font-weight: 300;
        font-size: 16px;
        color: rgba(45, 48, 53, 0.9);
        margin-bottom: 0;
    `,
    SubTitle: styled.h3`
        margin-bottom: 24px;
        text-transform: uppercase;
        font-weight: 500;
        font-size: 20px;
    `,
    HeadingContainer: styled.div`
        margin-bottom: 24px;
        display: flex;
        flex-direction: row;
        align-items: end;
        width: 100%;
    `,
    AddWrapper: styled.div`
        margin: auto 0 0 auto;
    `,
    DisabledAddWrapper: styled.div`
        display: flex;
        flex-direction: column;
    `,
    Error: styled.p`
        color: ${$danger};
        font-size: 12px;
        margin: 0;
    `,
}

const AddJobButton = () => {
    const amountOfJobs = useSelector(selectJobs).length
    const booth = useSelector(selectBooth)
    const maxJobs = booth?.max_job_openings || 0
    const maxJobsReached = maxJobs <= amountOfJobs
    return maxJobsReached
        ? (
            <S.DisabledAddWrapper>
                <Button disabled>
                    {_('booth.jobs.add_new')}
                </Button>
                <S.Error>
                    {`Max amount of jobs (${maxJobs}) has been reached`}
                </S.Error>
            </S.DisabledAddWrapper>
        )
        : (
            <Link to="new_job">
                <Button>
                    {_('booth.jobs.add_new')}
                </Button>
            </Link>
        )
}

const JobsConfig = () => {
    const dispatch = useDispatch()
    const params = useParams<Slugs>()
    useEffect(() => {
        dispatch(fetchJobs(params))
        dispatch(fetchBooth({ ...params, boothSlug: params.boothSlug }))
    }, [dispatch, params])
    return (
        <Container className="my-4">
            <S.HeadingContainer>
                <div>
                    <S.Title>{_('booth.jobs.page_title')}</S.Title>
                    <S.Description>{_('booth.jobs.page_description')}</S.Description>
                </div>

                <S.AddWrapper>
                    <AddJobButton />
                </S.AddWrapper>
            </S.HeadingContainer>

            <Card>
                <JobsOverview />
            </Card>
        </Container>
    )
}
export default JobsConfig
